"use strict";

exports.__esModule = true;
exports.default = void 0;
const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'INIT_DOWNLOADAPP':
      return {
        ...state,
        headerImage: action.data.headerImage,
        downloadLink: action.data.downloadLink,
        downloadLinkMac: action.data.downloadLinkMac,
        downloadText: action.data.downloadText,
        downloadTextMac: action.data.downloadTextMac,
        headerText: action.data.headerText,
        descriptionText: action.data.descriptionText,
        additionalText: action.data.additionalText
      };
    default:
      return state;
  }
};
var _default = exports.default = reducer;
module.exports = exports.default;